import React from 'react';
import RecentBlogs from '../../components/Blogs/Blogs/RecentBlogs';
import AllBlogs from '../../components/Blogs/Blogs/AllBlogs';

const Blogs = () => {
  return (
    <div className=" ">
      <RecentBlogs />
      <AllBlogs />
    </div>
  );
};

export default Blogs;
